import ModalRouteStack from './stack'
import WrapperLayout from './wrapper-layout'
import CreateModalRouteWrapper from './create.wrapper'
import CreateModalRouteProvider from './create.provider'
import CreateModalRouteContainer from './create.container'

export * from './helpers'

class ModalRouteBase {
  Provider = CreateModalRouteProvider()
  Wrapper = CreateModalRouteWrapper()
  WrapperLayout = WrapperLayout
  Container = CreateModalRouteContainer()
  createContainer = CreateModalRouteContainer
  show = ModalRouteStack.PushStack
  replace = ModalRouteStack.Replace
  close = <IQueryParam>(keyUseds?: keyof IQueryParam | (keyof IQueryParam)[]) => {
    const list = keyUseds ? (Array.isArray(keyUseds) ? keyUseds : [keyUseds]) : []
    ModalRouteStack.PopStack(
      list.reduce<{ [key in keyof IQueryParam]?: any }>((a, b) => {
        a[b] = ''
        return a
      }, {})
    )
  }
}

export const ModalRoute = new ModalRouteBase()

export * from './create.wrapper'
